<template>
    <Form>
        <h2>Account activation</h2>

        <p class="text-h6">Please check your email <strong>{{email}}</strong></p>
        <p>
            We've sent you a link to confirm your account.
            We may need to send you critical information about our service and it is important that we have an accurate email address.
        </p>

        <v-btn block class="blue-btn" :loading="loading" @click="send">Click here to resend your activation email</v-btn>
        <div v-if="message" class="font-italic green--text">{{message}}</div>
        <div v-if="error" class="font-italic red--text">{{error}}</div>

        <div class="pa-12">
            <p class="text-center">
                Wrong email?
                <router-link :to="{name: 'logout', query: $route.query}">Log Out.</router-link>
            </p>
        </div>
    </Form>
</template>

<script>
import Form from "@/pages/Form";
export default {
    components: {Form},
    props: {
        email: String,
    },

    data() {
        return {
            message: '',
            error: '',
            loading: false,
        };
    },

    methods: {
        send() {
            this.loading = true;
            this.message = '';
            this.error = '';
            this.$api.sendActivationEmail((_, meta) => {
                this.loading = false;
                const ok = meta.code < 400;
                this.message = ok ? 'activation email sent successfully' : '';
                this.error = !ok ? 'failed to send activation email, please try again later' : '';
            });
        },
    },
};
</script>

<style scoped>

</style>
